"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const moment_timezone_1 = __importDefault(require("moment-timezone"));
class EarningWindow {
    constructor(window, group) {
        // This function assumes that you are passing in a date time that is the same 
        // hours offset from begining of day as the classtime to recieve the correct slot
        this.getSlot = (epoch, testBackwards = false) => {
            const epochAdjust = 3;
            let count = this.window.startSlot;
            let slot = -1;
            if (this.window.startAt <= epoch) {
                for (let index = this.window.startAt; index <= epoch; index += EarningWindow.day) {
                    const days = Math.ceil(index / EarningWindow.day);
                    const dow = (days + epochAdjust) % 7;
                    if (this.window.type !== 'rotating' || (dow > 0 && dow < 6)) {
                        slot = count % this.window.slots.length;
                        count++;
                    }
                    else {
                        slot = -1;
                    }
                }
            }
            if (this.window.startAt > epoch && testBackwards) {
                for (let index = this.window.startAt; index > epoch; index -= EarningWindow.day) {
                    const days = Math.floor(index / EarningWindow.day);
                    const dow = (days + epochAdjust) % 7;
                    if (this.window.type !== 'rotating' || (dow > 0 && dow < 6)) {
                        slot = this.window.slots.length - 1 - (count % this.window.slots.length);
                        count++;
                    }
                    else {
                        slot = -1;
                    }
                }
            }
            return slot;
        };
        // This function assumes that you are passing in a date time that is start of day
        // for the day you are testing for slot.  This is used in the create classwide 
        // rewards calendar
        this.getSlotFromDayBegin = (epoch, testBackwards = false) => {
            const epochAdjust = 3;
            let count = this.window.startSlot;
            let slot = -1;
            let offset = 0;
            if (this.window.startAt <= epoch) {
                for (let index = this.window.startAt; index <= epoch + offset; index += EarningWindow.day) {
                    const days = Math.ceil(index / EarningWindow.day);
                    const dow = (days + epochAdjust) % 7;
                    if (this.window.type !== 'rotating' || (dow > 0 && dow < 6)) {
                        slot = count % this.window.slots.length;
                        count++;
                    }
                    else {
                        slot = -1;
                    }
                    const nextSlot = (count + 1) % this.window.slots.length;
                    offset = this.window.slots[nextSlot].start;
                }
            }
            if (this.window.startAt > epoch && testBackwards) {
                for (let index = this.window.startAt; index > epoch + offset; index -= EarningWindow.day) {
                    const days = Math.floor(index / EarningWindow.day);
                    const dow = (days + epochAdjust) % 7;
                    if (this.window.type !== 'rotating' || (dow > 0 && dow < 6)) {
                        slot = this.window.slots.length - 1 - (count % this.window.slots.length);
                        count++;
                    }
                    else {
                        slot = -1;
                    }
                    const nextSlot = (count + 1) % this.window.slots.length;
                    offset = this.window.slots[nextSlot].start;
                }
            }
            return slot;
        };
        this.isInWindow = (epoch, testBackwards = false) => {
            const slot = this.getSlot(epoch, testBackwards);
            const startOfDay = moment_timezone_1.default
                .unix(epoch)
                .startOf('day')
                .unix();
            const startWindow = startOfDay + this.window.slots[slot].start;
            const endWindow = startOfDay + this.window.slots[slot].end;
            if (!this.window.slots[slot].enabled) {
                return false;
            }
            return epoch >= startWindow && epoch <= endWindow;
        };
        this.getSecondsInWindow = (start, end, testBackwards = false) => {
            const startOfDay = moment_timezone_1.default
                .unix(start)
                .startOf('day')
                .unix();
            let totalSeconds = 0;
            for (let index = startOfDay; index <= end; index = index + EarningWindow.day) {
                const slot = this.getSlot(index, testBackwards);
                let seconds;
                let startWindow;
                let endWindow;
                let timeStart;
                let timeEnd;
                if (slot > -1 && this.window.slots[slot].enabled) {
                    startWindow = index + this.window.slots[slot].start;
                    endWindow = index + this.window.slots[slot].end;
                    timeStart = start < startWindow ? startWindow : start;
                    timeEnd = end > endWindow ? endWindow : end;
                    seconds = timeEnd - timeStart;
                    if (seconds > 0) {
                        totalSeconds += seconds;
                    }
                }
            }
            return totalSeconds;
        };
        this.getDaysInWindow = (start, end, testBackwards = false) => {
            let days = 0;
            for (let index = start; index <= end; index =
                moment_timezone_1.default
                    .unix(index)
                    .endOf('day')
                    .unix() + 1) {
                const endOfDay = moment_timezone_1.default
                    .unix(index)
                    .endOf('day')
                    .unix();
                const slot = this.getSlot(index, testBackwards);
                const seconds = this.getSecondsInWindow(index, endOfDay, testBackwards);
                if (slot > -1 && seconds > 0 && this.window.slots[slot].enabled) {
                    days++;
                }
            }
            return days;
        };
        this.getNextSlot = (epoch, testBackwards = false) => {
            const slot = this.getSlot(epoch, testBackwards);
            if (slot === -1) {
                return this.getNextSlot(epoch + EarningWindow.day, testBackwards);
            }
            return { slot, epoch };
        };
        this.getStandardTimeString = (key) => {
            const enabledSlot = this.window.slots.find((slot) => {
                return slot.enabled;
            });
            const epochTime = enabledSlot ? enabledSlot[key] : EarningWindow[key];
            return this.timeToString(epochTime);
        };
        this.getAverageDuration = () => {
            const seconds = this.window.slots.reduce((seconds, slot) => {
                return slot.enabled ? seconds + (slot.end - slot.start) : seconds;
            }, 0);
            const length = this.window.slots.filter((slot) => slot.enabled).length;
            return Math.round(seconds / length);
        };
        this.setRotatingSlotsLength = (length) => {
            const count = length - this.window.slots.length;
            if (this.window.type === 'rotating') {
                for (let index = 0; index < count; index++) {
                    this.window.slots.push({ start: 8 * 3600, end: 9 * 3600, enabled: true });
                }
                for (let index = 0; index > count; index--) {
                    this.window.slots.pop();
                }
            }
            return this.window;
        };
        this.setRotatingLabelType = (labelType) => {
            if (this.window.type === 'rotating') {
                this.window.labelType = labelType;
            }
            return this.window;
        };
        this.setRotatingStartAt = (epoch) => {
            if (this.window.type === 'rotating') {
                this.window.startAt = epoch;
            }
            return this.window;
        };
        this.setRotatingStartSlot = (slot) => {
            if (this.window.type === 'rotating') {
                this.window.startSlot = slot;
            }
            return this.window;
        };
        this.setSlotTime = (key, time, slotIndex, allSlots = false) => {
            const timeEpoch = moment_timezone_1.default(time, 'HH:mm').unix() -
                moment_timezone_1.default()
                    .startOf('day')
                    .unix();
            this.window = Object.assign(Object.assign({}, this.window), { slots: this.window.slots.map((slot, index) => {
                    const newSlot = Object.assign({}, slot);
                    if (slotIndex === index || allSlots) {
                        newSlot[key] = timeEpoch;
                    }
                    return newSlot;
                }) });
            return this.window;
        };
        this.toggleSlotEnabled = (slotIndex) => {
            this.window = Object.assign(Object.assign({}, this.window), { slots: this.window.slots.map((slot, index) => {
                    const newSlot = Object.assign({}, slot);
                    if (slotIndex === index) {
                        newSlot.enabled = !slot.enabled;
                    }
                    return newSlot;
                }) });
            return this.window;
        };
        this.timeToString = (epochTime) => {
            const epoch = this.window.startAt + epochTime;
            const time = moment_timezone_1.default.unix(epoch).format('HH:mm');
            return time;
        };
        this.mergeSlots = (slots) => {
            const merged = this.window.slots.map((slot, index) => {
                return slots[index] ? slots[index] : slot;
            });
            this.window = Object.assign(Object.assign({}, this.window), { slots: merged });
            return this.window;
        };
        /* START SECTION: this section is reserved for group based utilities */
        this.getSlotsFromGroup = (group) => {
            return group && group.attributes.window.rotation ? group.attributes.window.rotation.slots : [];
        };
        this.setSlotsFromGroup = (group) => {
            const startOfDay = moment_timezone_1.default()
                .startOf('day')
                .unix();
            const groupSlots = this.getSlotsFromGroup(group);
            const firstStandardSlot = groupSlots.find((groupSlot) => !(groupSlot.end === '00:00' && groupSlot.start === '00:00'));
            const slots = this.window.slots.map((slot, index) => {
                let groupSlot;
                let enabled;
                if (this.window.type === 'standard') {
                    groupSlot = firstStandardSlot ? firstStandardSlot : { start: '08:00', end: '09:00' };
                    enabled = groupSlots[index] ? !(groupSlots[index].end === '00:00' && groupSlots[index].start === '00:00') : slot.enabled;
                    return {
                        end: groupSlot.end === '00:00' ? EarningWindow.end : moment_timezone_1.default(groupSlot.end, 'HH:mm').unix() - startOfDay,
                        start: groupSlot.start === '00:00' ? EarningWindow.start : moment_timezone_1.default(groupSlot.start, 'HH:mm').unix() - startOfDay,
                        enabled,
                    };
                }
                if (groupSlots[index]) {
                    groupSlot = groupSlots[index];
                    enabled = !(groupSlot.end === '00:00' && groupSlot.start === '00:00');
                    return {
                        end: groupSlot.end === '00:00' ? EarningWindow.end : moment_timezone_1.default(groupSlot.end, 'HH:mm').unix() - startOfDay,
                        start: groupSlot.start === '00:00' ? EarningWindow.start : moment_timezone_1.default(groupSlot.start, 'HH:mm').unix() - startOfDay,
                        enabled,
                    };
                }
                return slot;
            });
            this.window = Object.assign(Object.assign({}, this.window), { slots });
        };
        this.getGroupWindow = () => {
            const groupWindow = {
                dow: null,
                startFormatted: null,
                endFormatted: null,
                rotation: {
                    numSlots: this.window.slots.length,
                    reference: {
                        date: moment_timezone_1.default.unix(this.window.startAt).format('YYYY-MM-DD'),
                        slot: this.window.startSlot,
                    },
                    slots: this.window.slots.map((slot) => {
                        return {
                            start: slot.enabled ? this.timeToString(slot.start) : '00:00',
                            end: slot.enabled ? this.timeToString(slot.end) : '00:00',
                        };
                    }),
                    type: this.window.labelType === 'numeric' ? '123' : 'abc',
                },
                timeZone: this.window.timeZone,
            };
            return groupWindow;
        };
        this.window = Object.assign(Object.assign({}, window), { slots: [...window.slots] });
        if (group) {
            this.setSlotsFromGroup(group);
        }
    }
}
exports.default = EarningWindow;
EarningWindow.day = 86400;
EarningWindow.start = 8 * 3600;
EarningWindow.end = 9 * 3600;
EarningWindow.rotatingWindow = () => {
    return {
        labelType: 'numeric',
        startAt: moment_timezone_1.default()
            .startOf('day')
            .unix(),
        startSlot: 0,
        slots: [
            { start: EarningWindow.start, end: EarningWindow.end, enabled: true },
            { start: EarningWindow.start, end: EarningWindow.end, enabled: true },
            { start: EarningWindow.start, end: EarningWindow.end, enabled: true },
            { start: EarningWindow.start, end: EarningWindow.end, enabled: true },
            { start: EarningWindow.start, end: EarningWindow.end, enabled: true },
        ],
        timeZone: moment_timezone_1.default.tz.guess(),
        type: 'rotating',
    };
};
EarningWindow.weeklyWindow = () => {
    return {
        labelType: 'numeric',
        startAt: moment_timezone_1.default()
            .startOf('isoWeek')
            .startOf('day')
            .unix(),
        startSlot: 0,
        slots: [
            { start: EarningWindow.start, end: EarningWindow.end, enabled: true },
            { start: EarningWindow.start, end: EarningWindow.end, enabled: true },
            { start: EarningWindow.start, end: EarningWindow.end, enabled: true },
            { start: EarningWindow.start, end: EarningWindow.end, enabled: true },
            { start: EarningWindow.start, end: EarningWindow.end, enabled: true },
            { start: EarningWindow.start, end: EarningWindow.end, enabled: false },
            { start: EarningWindow.start, end: EarningWindow.end, enabled: false },
        ],
        timeZone: moment_timezone_1.default.tz.guess(),
        type: 'weekly',
    };
};
EarningWindow.standardWindow = () => {
    const window = EarningWindow.weeklyWindow();
    return Object.assign(Object.assign({}, window), { type: 'standard' });
};
